import $ from "jquery";
import {
    checkAmountLengthRegexExp,
    checkAmountRegexExp,
    checkSymbols,
    showToastNotify,
    TOASTR_ERROR,
    DEPOSITS_LINK
} from "./helpers";

const DEPOSIT_WITHDRAW_MODAL = $('#dwModal'),
    DW_BTN_ACTION = $('#dw-btn-action'),
    DW_MIN_USD_AMOUNT = $('#dw-min-usd-amount'),
    DW_ADDRESS_ERROR = $('#dw-address-err'),
    DW_ADDRESS = $('#dw-address'),
    DW_AMOUNT = $('#dw-amount'),
    DW_FEE_VALUE = $('#dw-fee-value'),
    DW_NETWORK_FEE = $('#dw-network-fee'),
    DW_NETWORK_FEE_BLOCK = $('#dw-network-fee-block'),
    DW_CURR_ERROR = $('#dw-curr-err'),
    DW_MAX_AMOUNT_ERROR = $('#dw-max-amount-err'),
    DW_MIN_AMOUNT_ERROR = $('#dw-min-amount-err'),
    DW_EMPTY_AMOUNT_ERROR = $('#dw-empty-amount-err'),
    DR_ACTION = $('#dr-action'),
    DR_ADDR_BLOCK = $('#dr-addr-block'),
    DR_ADDR = $('#dr-addr'),
    DR_ADDR_STATUS = $('#dr-addr-status'),
    DR_STATUS_PENDING = $('#dr-status-pending'),
    DR_STATUS_CONFIRMED = $('#dr-status-confirmed'),
    CONFIRM_DW_ADDRESS = $('#dwc-address'),
    CONFIRM_DW_AMOUNT = $('#dwc-amount'),
    CONFIRM_DW_CURR_CODE = $('#dwc-curr-code'),
    CONFIRM_DW_CURR_ID = $('#dwc-curr-id'),
    CONFIRM_DW_BTN = $('#confirm-dw-btn'),
    CONFIRM_DW_REQUEST_MODAL = $('#confirmDWRequest'),
    NON_VISIBLE = 'd-none',
    ERROR_COLOR = 'error-color',
    ERROR_INPUT_DATA = 'error-input-group',
    INFO_BACKGR = 'info-background',
    INFO_BACKGR_SELECT = 'info-background-select';

let withdrawData = [];

function openDepositWithdrawModal() {
    changeDWData();
    getWithdrawAmount();
    DEPOSIT_WITHDRAW_MODAL.modal('show');
}

function depositActionMore() {
    location.href = '/deposit-terms'
}

function depositHistory() {
    location.href = '/deposit-history'
}

function getWithdrawAmount() {
    $.ajax({
        type: 'POST',
        url: '/deposit/withdrawal/amount',
        data: {},
        success: function (result) {
            if (result) {
                if (!result.error) {
                    withdrawData = result;
                } else {
                    return false;
                }
            }
        }
    });
}

function sendDepositWithdraw() {
    const currCode = CONFIRM_DW_CURR_CODE.text();
    const currId = CONFIRM_DW_CURR_ID.text();
    const amount = CONFIRM_DW_AMOUNT.text();
    const address = CONFIRM_DW_ADDRESS.text();
    $.ajax({
        type: 'POST',
        url: '/deposit/withdrawal',
        data: {
            'addr': address,
            'amount': amount,
            'currCode': currCode,
            'currId': currId,
        },
        success: function (result) {
            if (result) {
                let msg = 'Something wrong';
                if (result.msg) {
                    msg = result.msg;
                }
                if (!result.error) {
                    showDWSuccess(result.addr, result.amount_usd, result.net_fee_usd, result.balance);
                } else {
                    showToastNotify(TOASTR_ERROR, '', msg)
                }
            }
        }
    });
}

function showDWSuccess(address, amountUsd, netFeeUsd, depositBalance) {
    CONFIRM_DW_REQUEST_MODAL.modal('hide');
    $('#dws-amount').text(amountUsd);
    $('#dws-address').text(address);
    $('#dws-net-fee').text(netFeeUsd);
    $('#dws-balance').text(depositBalance);
    $('#dwSuccess').modal('show');
}

function changeDwCurrCode() {
    changeDWData();
    if (!withdrawData || withdrawData.length == 0) {
        return;
    }
    const currCode = getDWCurrCode()
    if (!currCode || currCode === 'undefined') {
        DW_NETWORK_FEE_BLOCK.addClass(NON_VISIBLE)
        DW_CURR_ERROR.removeClass(NON_VISIBLE)
    } else {
        setDwFeeData(currCode);
        DW_NETWORK_FEE_BLOCK.removeClass(NON_VISIBLE)
    }
}

function setDwFeeData(currCode) {
    const DW_FEE_AMOUNT = $('#dw-fee-amount')
    const DW_FEE_CURRENCY = $('#dw-fee-currency')
    const DW_FEE_AMOUNT_USD = $('#dw-fee-amount-usd')
    const DW_FEE_USD = $('#dw-fee-usd')
    const DW_FEE_BKT = $('#dw-fee-bkt')
    if (currCode === 'ERC20') {
        DW_FEE_AMOUNT.addClass(ERROR_COLOR);
        DW_FEE_CURRENCY.addClass(ERROR_COLOR);
        DW_FEE_AMOUNT_USD.addClass(ERROR_COLOR);
        DW_FEE_USD.addClass(ERROR_COLOR);
        DW_FEE_BKT.addClass(ERROR_COLOR);
    } else {
        if (DW_FEE_AMOUNT.hasClass(ERROR_COLOR)) {
            DW_FEE_AMOUNT.removeClass(ERROR_COLOR)
        }
        if (DW_FEE_CURRENCY.hasClass(ERROR_COLOR)) {
            DW_FEE_CURRENCY.removeClass(ERROR_COLOR)
        }
        if (DW_FEE_AMOUNT_USD.hasClass(ERROR_COLOR)) {
            DW_FEE_AMOUNT_USD.removeClass(ERROR_COLOR)
        }
        if (DW_FEE_USD.hasClass(ERROR_COLOR)) {
            DW_FEE_USD.removeClass(ERROR_COLOR)
        }
        if (DW_FEE_BKT.hasClass(ERROR_COLOR)) {
            DW_FEE_BKT.removeClass(ERROR_COLOR)
        }
    }

    const feeAmount = parseFloat(withdrawData['fee' + currCode])
    const feeCurrency = withdrawData['feeCurr' + currCode]
    const feeUsd = parseFloat(withdrawData['feeUsd' + currCode])
    DW_FEE_AMOUNT.text(feeAmount);
    DW_FEE_CURRENCY.text(feeCurrency);
    DW_FEE_AMOUNT_USD.text(feeUsd);
}

function changeDWData() {
    const dwAmount = DW_AMOUNT.val().replace(',', '.');

    if (DW_ADDRESS.hasClass(ERROR_INPUT_DATA)) {
        DW_ADDRESS.removeClass(ERROR_INPUT_DATA);
    }
    if (DW_AMOUNT.hasClass(ERROR_INPUT_DATA)) {
        DW_AMOUNT.removeClass(ERROR_INPUT_DATA);
    }
    if (!DW_CURR_ERROR.hasClass(NON_VISIBLE)) {
        DW_CURR_ERROR.addClass(NON_VISIBLE);
    }
    if (!DW_ADDRESS_ERROR.hasClass(NON_VISIBLE)) {
        DW_ADDRESS_ERROR.addClass(NON_VISIBLE);
    }
    if (!DW_EMPTY_AMOUNT_ERROR.hasClass(NON_VISIBLE)) {
        DW_EMPTY_AMOUNT_ERROR.addClass(NON_VISIBLE);
    }
    if (!DW_MAX_AMOUNT_ERROR.hasClass(NON_VISIBLE)) {
        DW_MAX_AMOUNT_ERROR.addClass(NON_VISIBLE);
    }
    if (!DW_MIN_AMOUNT_ERROR.hasClass(NON_VISIBLE)) {
        DW_MIN_AMOUNT_ERROR.addClass(NON_VISIBLE);
    }

    const checkAmountRegex = checkAmountRegexExp(dwAmount)
    if (checkAmountRegex) {
        DW_AMOUNT.val(checkAmountRegex);
    }

    const checkAmountLengthRegex = checkAmountLengthRegexExp(DW_AMOUNT.val())
    if (checkAmountLengthRegex) {
        DW_AMOUNT.val(checkAmountLengthRegex);
    }
}

function changeDrCurrCode() {
    DR_ACTION.removeClass(NON_VISIBLE)
    DR_ADDR_BLOCK.addClass(NON_VISIBLE);
    $('#drQrCodeBlock').addClass(NON_VISIBLE)
    $('#dr-qr-code-url').addClass(NON_VISIBLE)
}

function setInactiveDRActionBtc(state) {
     DR_ACTION.prop('disabled', state);
}

function getDepositRefillAddress() {
    setInactiveDRActionBtc(true)
    let data = {
        'code': getDRCurrCode(),
    }
    $.ajax({
        type: 'POST',
        url: '/deposit/getaddr',
        data: data,
        success: function (result) {
            let errorMsg = 'Something wrong';
            if (result) {
                if (!result.error && result.addr) {
                    activateAddressBlock(result.addr);
                } else {
                    if (result.msg) {
                        errorMsg = result.msg;
                    }
                    showToastNotify(TOASTR_ERROR, '', errorMsg)
                    setInactiveDRActionBtc(false)
                }
            }
        }
    });
}

function activateAddressBlock(address) {
    DR_ACTION.addClass(NON_VISIBLE)
    DR_ADDR_BLOCK.removeClass(NON_VISIBLE);
    DR_ADDR.val(address)
}

const getDRCurrCode = () => {
    return $("#dr-curr-code :selected").val();
}

const getDWCurrCode = () => {
    return $("#dw-curr-code :selected").val();
}

const getDWCurrId = () => {
    return $("#dw-curr-code :selected").attr('id');
}

const changeDWAmount = () => {
    checkSymbols('dw-amount');
    const dwAmount = DW_AMOUNT;
    const dwAddress = DW_ADDRESS;
    if (dwAddress.hasClass(ERROR_INPUT_DATA)) {
        dwAddress.removeClass(ERROR_INPUT_DATA);
    }
    if (dwAmount.hasClass(ERROR_INPUT_DATA)) {
        dwAmount.removeClass(ERROR_INPUT_DATA);
    }
}

const withdrawActiveFields = () => {
    $('#dw-amount').focusin(function () {
        $('#dw-prepend-code').addClass('info-background');
    });
    $('#dw-amount').focusout(function () {
        $('#dw-prepend-code').removeClass('info-background');
    });
}

const hideWithdrawSuccess = () => {
    $('#dwSuccess').on('hidden.bs.modal', function (e) {
        window.location.reload();
    })
}

const hideWithdraw = () => {
    DEPOSIT_WITHDRAW_MODAL.on('hidden.bs.modal', function (e) {
        setDefaultData();
    })
}

function setDefaultData() {
    changeDWData()
    DW_AMOUNT.val('')
    DW_ADDRESS.val('')
    $("#dw-curr-code").val('');
    DW_NETWORK_FEE_BLOCK.addClass(NON_VISIBLE)
}

function depositWithdraw() {
    const amount = parseFloat(DW_AMOUNT.val().replace(',', '.'));
    const address = DW_ADDRESS.val();
    const currCode = getDWCurrCode()
    const currId = getDWCurrId()
    CONFIRM_DW_BTN.prop('disabled', false);
    const maxAmount = parseFloat(withdrawData['maxUsdt' + currCode])
    const minAmount = parseFloat(withdrawData['minUsdt' + currCode])
    if (!amount || !address || !currCode || !currId ||
        (amount > maxAmount) || maxAmount <= 0 || amount <= 0) {
        if (!amount) {
            DW_AMOUNT.addClass(ERROR_INPUT_DATA);
        }
        if (!address) {
            DW_ADDRESS.addClass(ERROR_INPUT_DATA);
            DW_ADDRESS_ERROR.removeClass(NON_VISIBLE)
        }
        if (amount > maxAmount || maxAmount < 0) {
            DW_AMOUNT.addClass(ERROR_INPUT_DATA);
            DW_MAX_AMOUNT_ERROR.removeClass(NON_VISIBLE)
        }
        if (amount <= 0) {
            DW_AMOUNT.addClass(ERROR_INPUT_DATA);
            DW_EMPTY_AMOUNT_ERROR.removeClass(NON_VISIBLE)
        }

        if (!currCode || !currId) {
            DW_CURR_ERROR.removeClass(NON_VISIBLE)
        }
    } else {
        changeDWData();
        CONFIRM_DW_ADDRESS.text(address);
        CONFIRM_DW_AMOUNT.text(amount);
        CONFIRM_DW_CURR_CODE.text(currCode);
        CONFIRM_DW_CURR_ID.text(currId);
        DEPOSIT_WITHDRAW_MODAL.modal('hide');
        CONFIRM_DW_REQUEST_MODAL.modal('show');
    }
}

const confirmDWAction = (btn) => {
    btn.disabled = true;
    sendDepositWithdraw();
}

function setMaxDWAmount() {
    const currCode = getDWCurrCode()
    if (currCode) {
        const maxAmount = parseFloat(withdrawData['maxUsdt' + currCode])
        DW_AMOUNT.val(maxAmount);
    }
}

window.openDepositWithdrawModal = openDepositWithdrawModal;
window.depositActionMore = depositActionMore;
window.depositHistory = depositHistory;
window.depositWithdraw = depositWithdraw;
window.changeDWData = changeDWData;
window.changeDrCurrCode = changeDrCurrCode;
window.getDepositRefillAddress = getDepositRefillAddress;
window.changeDWAmount = changeDWAmount;
window.changeDwCurrCode = changeDwCurrCode;
window.confirmDWAction = confirmDWAction;
window.setMaxDWAmount = setMaxDWAmount;

$(document).ready(() => {
    hideWithdrawSuccess();
    hideWithdraw();
    withdrawActiveFields();

    if (window.location.pathname === DEPOSITS_LINK) {
        setInterval(function () {
            getWithdrawAmount();
        }, 60 * 1000);
    }
});
